import { render, staticRenderFns } from "./node.vue?vue&type=template&id=4b0819d1&scoped=true&"
import script from "./node.vue?vue&type=script&lang=js&"
export * from "./node.vue?vue&type=script&lang=js&"
import style0 from "./node.vue?vue&type=style&index=0&id=4b0819d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0819d1",
  null
  
)

export default component.exports